import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const DocxIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M22.0231 2.875C22.2147 2.87447 22.4045 2.91196 22.5815 2.98529C22.7586 3.05861 22.9193 3.16633 23.0544 3.30219L28.6875 8.93531C28.8233 9.07043 28.931 9.23114 29.0044 9.40815C29.0777 9.58517 29.1152 9.77496 29.1147 9.96656V27.6666C29.1147 28.4709 28.4538 29.125 27.6416 29.125H8.34812C7.53562 29.125 6.875 28.4709 6.875 27.6666V4.33344C6.875 3.52906 7.53594 2.875 8.34812 2.875H22.0231ZM22.0231 2H8.34812C7.05125 2 6 3.04469 6 4.33344V27.6666C6 28.9553 7.05125 30 8.34812 30H27.6416C28.9384 30 29.9897 28.9553 29.9897 27.6666V9.96656C29.9896 9.34771 29.7438 8.75421 29.3062 8.31656L23.6731 2.68344C23.2355 2.24592 22.642 2.0001 22.0231 2Z"
        fill="currentColor"
      />
      <path
        d="M22 2V7.33344C22.0001 8.04063 22.281 8.71883 22.7811 9.21889C23.2812 9.71895 23.9594 9.99992 24.6666 10H30L22 2Z"
        fill="currentColor"
      />
      <path
        d="M25.6667 20.3334H16.3334V21H25.6667C25.7551 21 25.8399 20.9649 25.9024 20.9024C25.9649 20.8399 26 20.7551 26 20.6667C26 20.5783 25.9649 20.4935 25.9024 20.431C25.8399 20.3685 25.7551 20.3334 25.6667 20.3334Z"
        fill="currentColor"
      />
      <path
        d="M25.6667 18.3334H16.3334V19H25.6667C25.7551 19 25.8399 18.9649 25.9024 18.9024C25.9649 18.8399 26 18.7551 26 18.6667C26 18.5783 25.9649 18.4935 25.9024 18.431C25.8399 18.3685 25.7551 18.3334 25.6667 18.3334Z"
        fill="currentColor"
      />
      <path
        d="M16.3334 17H25.6667C25.7551 17 25.8399 16.9649 25.9024 16.9024C25.9649 16.8399 26 16.7551 26 16.6667C26 16.5783 25.9649 16.4935 25.9024 16.431C25.8399 16.3685 25.7551 16.3334 25.6667 16.3334H16.3334V17Z"
        fill="currentColor"
      />
      <path
        d="M25.6667 14.3334H16.3334V15H25.6667C25.7551 15 25.8399 14.9649 25.9024 14.9024C25.9649 14.8399 26 14.7551 26 14.6667C26 14.5783 25.9649 14.4935 25.9024 14.431C25.8399 14.3685 25.7551 14.3334 25.6667 14.3334Z"
        fill="currentColor"
      />
      <path
        d="M3.33333 24.3333H14C14.3536 24.3333 14.6928 24.1929 14.9428 23.9428C15.1929 23.6928 15.3333 23.3536 15.3333 23V12.3333C15.3333 11.9797 15.1929 11.6406 14.9428 11.3905C14.6928 11.1405 14.3536 11 14 11H3.33333C2.97971 11 2.64057 11.1405 2.39052 11.3905C2.14048 11.6406 2 11.9797 2 12.3333V23C2 23.3536 2.14048 23.6928 2.39052 23.9428C2.64057 24.1929 2.97971 24.3333 3.33333 24.3333Z"
        fill="currentColor"
      />
      <path
        d="M6.54167 19.8817C6.56367 20.0557 6.578 20.2074 6.585 20.337H6.61C6.64058 20.0397 6.6881 19.7443 6.75233 19.4524L7.93033 14.3334H9.45367L10.6723 19.3757C10.7333 19.6247 10.7843 19.9414 10.8247 20.3267H10.845C10.862 20.061 10.9043 19.754 10.972 19.4064L11.947 14.3334H13.3333L11.6273 21.6667H10.0073L8.84433 16.8087C8.81067 16.6687 8.77233 16.4864 8.73 16.2614C8.69742 16.0989 8.67118 15.9352 8.65133 15.7707H8.63133C8.61767 15.89 8.59133 16.0674 8.55233 16.3024C8.5244 16.4769 8.49306 16.6508 8.45833 16.824L7.36667 21.6667H5.72133L4 14.3334H5.41167L6.473 19.4627C6.49667 19.5684 6.51967 19.708 6.54167 19.882V19.8817Z"
        fill="#F9F7F7"
      />
    </SvgIcon>
  );
};

export default memo(DocxIcon);
